import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {Container, Menu, Image } from 'semantic-ui-react';
import styles from "./col-header.module.css";
import Helper from "./Helper";
import withBreadcrumbs from "react-router-breadcrumbs-hoc";
import routesConfig from "../config/routesConfig";
import {PAYCELL_LOGO} from '../constants'

function Header() {
    const [headerImage ,  setHeaderImage] = useState([]);
    const { getStorageItem,isExternalSdk} = Helper();

  let Breadcrumbs = ({ breadcrumbs }) => (
    <div>
      {breadcrumbs.map(({ breadcrumb, match }, index) => (
        <Link
          className={`${index < breadcrumbs.length - 1 ? 'breadcrumb' : 'breadcrumbDisable' }`}
          key={breadcrumb.key}
          to={match.url || ""}
        >
          {breadcrumb}
          {index < breadcrumbs.length - 1 && " > "}
        </Link>
      ))}
    </div>
  );

  Breadcrumbs = withBreadcrumbs(routesConfig, { disableDefaults: true })(
    Breadcrumbs
  );

    useEffect(async () => {
        setHeaderImage(getStorageItem("header"));
    }, []);

    return (
      <div>
        <Container style ={{marginTop:'150px'}}>
          <Breadcrumbs/>
        </Container>
        <div className={styles.mainDiv}>
          <Menu borderless fixed='top'>
            <Container text className={styles.container} >
              <Menu.Item as={Link} to="/" exact="true">
                {
                    !isExternalSdk() ? (
                        <>
                          <Image className={styles.image}  style={{height:'80px' , width: '360px'}}  src={PAYCELL_LOGO}/>
                          <label className={styles.label}>|</label>
                          <label className={styles.textRainbowAnimation}>Fatura Ödeme Merkezi</label>
                        </>
                      ) :
                      (
                        headerImage  && <Image className={styles.image} style={{height:'75px'}}  src={`data:image/png;base64,${headerImage.image}`}/>
                      )
                 }
              </Menu.Item>
            </Container>
          </Menu>
        </div>
      </div>
        );
}

export default Header;
